import React from 'react';
import loadable from '@loadable/component';

const InfoCard = loadable(
  () =>
    import(/* webpackChunkName: "InfoCard.loadable" */ 'app/shared/modules/MobileSRP/ListingCards/InfoCard/component'),
);

class LoadableInfoCard extends React.Component {
  render() {
    return <InfoCard {...this.props} />;
  }
}

export default LoadableInfoCard;
